"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _textInput = _interopRequireDefault(require("../../atoms/text-input"));

var _button = _interopRequireDefault(require("../../atoms/button"));

var _buttonGroup = _interopRequireWildcard(require("../../molecules/button-group"));

var _pixelcalculations = require("../../_utils/pixelcalculations");

var _tokens = require("../../../tokens");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", " {\n    ", ";\n  }\n\n  ", " {\n    position: absolute;\n    right: 4px;\n    top: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* TODO: export this property from button component */
var buttonWidth = '36px';

var Wrapper = _styledComponents["default"].div(_templateObject(), _textInput["default"].Element, function (props) {
  if (!props.actions) return;
  return "padding-right: calc(".concat((0, _pixelcalculations.multiply)(buttonWidth, props.actions.length), " + ").concat(_tokens.spacing.xsmall, ")");
}, _buttonGroup.StyledButtonGroup, function (props) {
  return props["native"] || props.placeholder ? 0 : '20px';
});

var ActionInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ActionInput, _React$Component);

  function ActionInput() {
    _classCallCheck(this, ActionInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActionInput).apply(this, arguments));
  }

  _createClass(ActionInput, [{
    key: "render",
    value: function render() {
      if (this.props.actions) {
        return _react["default"].createElement(Wrapper, this.props, _react["default"].createElement(_textInput["default"], _extends({}, this.props, {
          type: 'text'
        })), _react["default"].createElement(_buttonGroup["default"], {
          compressed: true
        }, this.props.actions.map(function (action, index) {
          return _react["default"].createElement(_button["default"], {
            view: "link",
            size: "small",
            key: index,
            icon: action.icon,
            onClick: action.method,
            label: action.label
          });
        })));
      } else {
        return _react["default"].createElement(_textInput["default"], this.props);
      }
    }
  }]);

  return ActionInput;
}(_react["default"].Component);

ActionInput.propTypes = _objectSpread({}, _textInput["default"].propTypes, {
  /** Actions to be attached */
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    icon: _propTypes["default"].string.isRequired,
    method: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].string.isRequired
  }))
});
ActionInput.defaultProps = _objectSpread({}, _textInput["default"].defaultProps, {
  actions: []
});
var _default = ActionInput;
exports["default"] = _default;